import { get, set } from 'lodash';
import { specialFilterColors } from '@utils/colorPalette';
import {
  generateColor,
} from '@utils/getColor';

/**
 * @param {object} data removed filter from compare data
 */
const removeFilterFromData = (data, index) => {
  if (data === null) return null;

  const specialColors = Array.from(specialFilterColors.values());
  const genColor = generateColor();

  /* Arrange colors */
  data.colors.splice(index, 1);
  set(data, 'colors', data.colors.map(color => (specialColors.includes(color) ? color : genColor.next().value)));

  data.filterMetaList.splice(index, 1);
  const { totalObj, dataObj } = data;
  data.metrics.forEach((metric) => {
    if (Array.isArray(totalObj[metric])) {
      totalObj[metric].splice(index, 1);
    }
    const series = get(dataObj, `${metric}.series`);
    if (Array.isArray(series)) {
      series.splice(index, 1);
      series.forEach((item, i) => set(item, 'itemStyle.color', data.colors[i]));
    }
  });

  set(data, 'totalObj', { ...totalObj });

  return { ...data };
};

export default removeFilterFromData;
